export default __webpack_public_path__ + "static/media/hand_book_bg.38c0c635.png";